<template>
  <formitem-wapper :formitem="formitem">
    <a-select :placeholder="placeholder"
              v-bind="widgetAttrs"
              show-search
              :filter-option="filterOption"
              v-decorator="[formitem.key,formitem.fieldDecoratorOptions]" allowClear>
      <a-select-option v-for="(item,index) in formitem.listSource"
                       :key="index"
                       :value="item.value">
        <span style="display: inline-block;width: 100%" :title="item.label">
          {{ item.label }}
        </span>
      </a-select-option>
    </a-select>
  </formitem-wapper>
</template>

<script>
import FormitemWapper from './../FormitemWapper.vue'
import { FormItemMixin } from './../FormItenMixin'

export default {
  name: 'SelectWidget',
  mixins: [FormItemMixin],
  components: {
    FormitemWapper
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[ 0 ].children[ 0 ].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    }
  }
}
</script>